import { FSBrand, mapFSBrand } from "../Brand";
import { FSColor, mapFSColor } from "../Color";
import { FSLocation, mapFSLocation } from "../Location";
import { FSFileList, mapFSFileLists } from "../FileList";
import { FSAccessoryData, mapFSAccessoryDatas } from "../Accessory/AccessoryData";
import { FSDataOrder, mapFSDataOrder } from "../Order";

/* **************************************************** Finishing Shedule Paint Data */
export interface FSPaintData {
    id: number;
    fs_data_id: number;
    type: 'Wall' | 'Ceiling' | null;
    location_id: number | null;
    brand_id: number | null;
    color_id: number | null;
    color_code: string | null;
    link: string | null;
    image_path: string | null;
    file_list: FSFileList[];
    order_status: 'Pending' | 'Ordered' | 'Instore' | 'Onsite';
    order_date_data: string | null;
    order_date: string | null;
    order_data: FSDataOrder | null;
    location: FSLocation | null;
    brand: FSBrand | null;
    color: FSColor | null;
}

export const mapFSPaintData = (data: any): FSPaintData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSPaintData = {
        id: data.id,
        fs_data_id: data.fs_data_id,
        type: data.type || null,
        location_id: data.location_id || null,
        brand_id: data.brand_id || null,
        color_id: data.color_id || null,
        color_code: data.color_code || null,
        link: data.link || null,
        image_path: data.image_path || null,
        file_list: Array.isArray(data.file_list) ? mapFSFileLists(data.file_list) : [],
        order_status: data.order_status,
        order_date_data: data.order_date_data || null,
        order_date: data.order_date || null,
        order_data: data.order_data ? mapFSDataOrder(data.order_data) : null,
        location: data.location ? mapFSLocation(data.location) : null,
        brand: data.brand ? mapFSBrand(data.brand) : null,
        color: data.color ? mapFSColor(data.color) : null,
    };

    return res;
};

export const mapFSPaintDatas = (data: any[]): FSPaintData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSPaintData);
};


/* **************************************************** Finishing Shedule Paint */
export interface FSPaint {
    id: number;
    fs_feature_id: number;
    category: string;
    location_name: string | null;
    location_id: number | null;
    is_default_feature: 1 | 0;
    data_paint: FSPaintData[];
    data_accessory: FSAccessoryData[];
}

export const mapFSPaint = (data: any): FSPaint => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSPaint = {
        id: data.id,
        fs_feature_id: data.fs_feature_id,
        category: data.category,
        location_name: data.location_name || null,
        location_id: data.location_id || null,
        is_default_feature: data.is_default_feature,
        data_paint: Array.isArray(data.data_paint) ? mapFSPaintDatas(data.data_paint) : [],
        data_accessory: Array.isArray(data.data_accessory) ? mapFSAccessoryDatas(data.data_accessory) : [],
    };

    return res;
};

export const mapFSPaints = (data: any[]): FSPaint[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSPaint);
};
